import * as React from 'react'

import { Typography } from "@mui/material";
import { NotAllowedBlock } from "@components";


export default function winnercolumn() {
    return {
        name: 'winner', label: 'Winner (Best Price)',
        options: {
            customBodyRowRenderLite: (value) => <Typography sx={{ fontSize: '0.875rem', textAlign: 'center' }}>
                { !!value ? value : <NotAllowedBlock /> }
            </Typography>

        }
    }
}